import { legacyRedirectMap } from '../../config/redirects';
import { env } from '../../config/runtime';

// Static map only — flag-conditional bookmarks live in `FLAGGED_LEGACY_REDIRECTS`
// and are handled by `resolveLegacyRedirectTarget` in `useLegacyRedirect.ts`.
export function resolveLegacyRedirect(pathname: string, domain: string): string | undefined {
  const normalized = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  const targetFn = legacyRedirectMap.get(normalized);
  return targetFn?.(domain);
}

/** Convenience wrapper resolving against the current runtime domain; falls back to `path` when there's no redirect. */
export function legacyHref(path: string): string {
  return resolveLegacyRedirect(path, env.waipuDomain) ?? path;
}
